export default "__VITE_ASSET__BB5umbG0__"